export default __webpack_public_path__ + "static/media/12D.0f139f23.webp";